export { default } from './DiscountLockSmsOptIn';
